export default __webpack_public_path__ + "static/wag_dog_desktop-984d4524fe6535d37403e3e0f0c50d7c.png";